import { Price, UnitPrice } from '../../models/pricing.model';
import { Quantity } from '../../models/quantity.model';

export class Formatter {
   // eslint-disable-next-line no-useless-constructor
   constructor(private locale: string) {}

   dateTime(
      value: Date | string,
      options: Intl.DateTimeFormatOptions = {
         year: 'numeric',
         month: '2-digit',
         day: '2-digit',
         timeZone: 'UTC'
      }
   ) {
      const date = value instanceof Date ? value : new Date(value);
      return Intl.DateTimeFormat(this.locale, options).format(date);
   }

   number(value: number, options?: Intl.NumberFormatOptions) {
      return Intl.NumberFormat(this.locale, options).format(value);
   }

   price(value: Price) {
      return this.number(value.amount, { style: 'currency', currency: value.currency });
   }

   quantity(value: Quantity) {
      return `${this.number(value.amount)} ${value.unitOfMeasure}`;
   }

   unitPrice(value: UnitPrice) {
      return `${this.number(value.price.amount, {
         style: 'currency',
         currency: value.price.currency,
         minimumFractionDigits: 2,
         maximumFractionDigits: 3
      })} / ${value.unitOfMeasure}`;
   }
}
